import { get, post, put } from "../client";
import { MODELS } from "../routes";

export default {
  get: async (data) => await get(MODELS, data),

  create: async (data) => await post(MODELS, data),
};
